export default __webpack_public_path__ + "static/media/Untitled-1.4db7a301.jpeg";